import dict from '@/store/dict/maintenanceOrder'

const {
  payStates,
  itemType,
  orderState,
  refundStates,
  examStates,
} = dict
const getFormatter = (type) => {
  return (value) => type[value]
}

export default function () {
  // 订单基本信息
  const allBaseInfo = [
    {
      key: 'parentOrderId',
      name: '父单ID',
    },
    {
      key: 'orderId',
      name: '子单ID',
    },
    {
      key: 'payTradeId',
      name: '流水号',
    },
    {
      key: 'createTime',
      name: '下单时间',
    },
    {
      key: 'payTime',
      name: '支付时间',
    },
    {
      key: 'orderStateName',
      name: '订单状态',
    },
    {
      key: 'payState',
      name: '支付状态',
      formatter: getFormatter(payStates),
    },
    {
      key: 'itemType',
      name: '订单类型',
      formatter: getFormatter(itemType),
    },
    {
      key: 'itemName',
      name: '单品/套餐名称',
    },
  ]

  // 财务信息
  const allFinanceInfo = [
    {
      key: 'feeBearTypeName',
      name: '费用承担方',
    },
    {
      key: 'payChannelTypeName',
      name: '支付类型',
    },
    {
      key: 'payChannelName',
      name: '支付方式',
    },
    {
      key: 'amount',
      name: '订单优惠前金额',
    },
    {
      key: 'factAmount',
      name: '订单实付金额',
    },
    {
      key: 'discountAmount',
      name: '优惠金额',
    },
    {
      key: 'platformServiceFee',
      name: '服务费金额',
    },
    {
      key: 'usedAmount',
      name: '已核销金额',
    },
    {
      key: 'refundAmount',
      name: '已退款总金额',
    },
    {
      key: 'spCompanyId',
      name: '费用承担车队ID',
    },
    {
      key: 'spCompanyName',
      name: '费用承担车队名称',
    },
    {
      key: 'refundGoodsAmount',
      name: '商品退款金额',
    },
    {
      key: 'refundPlatformServiceFee',
      name: '服务费退款金额',
    },
    {
      key: 'energyIntegralNum',
      name: '抵扣的能量币',
    },
    {
      key: 'energyUseAmountOrder',
      name: '能量币抵扣订单金额',
    },
    {
      key: 'energyUseAmountServiceFee',
      name: '能量币抵扣服务费',
    },
    {
      key: 'refundEnergyIntegralNum',
      name: '已退回抵扣能量币',
    },
    {
      key: 'merchantCouponAmount',
      name: '商家优惠券',
    },
  ]
  // 营销
  const allMarketingInfo = [
    {
      key: 'earnEnergyIntegralNum',
      name: '获取的能量币',
    },
    {
      key: 'refundEarnEnergyIntegralNum',
      name: '已退回获取的能量币',
    },
  ]
  // 发票
  const allInvoiceInfo = [
    {
      key: 'invoiceTypeName',
      name: '维保发票开具方类型',
      toolTip: {
        content: '由SP/OSP开发票，或者由维修保养门店开发票',
      },
    },
  ]

  // 用户信息
  const userInfo = [
    {
      key: 'userId',
      name: '用户ID',
    },
    {
      key: 'channelUserId',
      name: '渠道用户ID',
    },
    {
      key: 'orderUserTypeName',
      name: '个人用户/车队用户',
    },
    {
      key: 'userNumber',
      name: '用户手机号',
      viewBtn: {
        showFn: () => {
          return (
            this.source &&
            this.source.userNumber &&
            this.source.userNumber.indexOf('*') > -1
          )
        },
        loading: false,
        clickFn: this.getMobile,
      },
    },

  ]
  // 维修厂信息
  const allStationInfo = [
    {
      key: 'tenantId',
      name: '服务商ID',
    },
    {
      key: 'tenantName',
      name: '服务商名称',
    },
    {
      key: 'businessId',
      name: '门店ID',
    },
    {
      key: 'businessName',
      name: '门店名称',
      alone: true,
    },
    {
      key: 'provinceName',
      name: '省',
      alone: true,
    },
    {
      key: 'cityName',
      name: '市',
      alone: true,
    },
    {
      key: 'countyName',
      name: '区',
      alone: true,
    },
    {
      key: 'businessAddress',
      name: '地址',
      alone: true,
    },
  ]

  // 订单日志
  const allOrderLogInfo = [
    {
      key: 'orderState',
      label: '操作类型',
      source: orderState,
    },
    {
      key: 'gmtCreate',
      label: '操作时间',
    },
  ]

  // 退款日志
  const allRefundLogInfo = [
    {
      key: 'orderId',
      label: '订单ID',
      width: 190,
    },
    {
      key: 'refundSourceName',
      label: '退款来源',
    },
    {
      key: 'refundBizTypeName',
      label: '退款类型',
    },
    {
      key: 'refundAmount',
      label: '退款总金额',
    },
    {
      key: 'refundGoodsAmount',
      label: '商品退款金额',
    },
    {
      key: 'refundPlatformServiceFee',
      label: '服务费退款金额',
    },
    {
      key: 'refundEnergyIntegralAmount',
      label: '退还能量积分金额',
      width: 100,
    },
    {
      key: 'refundState',
      label: '退款状态',
      source: refundStates,
    },
    {
      key: 'refundTime',
      label: '退款时间',
    },
    {
      key: 'createUser',
      label: '申请人姓名',
    },
    {
      key: 'applyRefundTime',
      label: '退款申请时间',
    },
    {
      key: 'examState',
      label: '乾三审核状态',
      source: examStates,
    },
    {
      key: 'externalExamTime',
      label: '服务商审核时间',
    },
  ]
  return {
    allBaseInfo,
    allFinanceInfo,
    allMarketingInfo,
    allInvoiceInfo,
    userInfo,
    allStationInfo,
    allOrderLogInfo,
    allRefundLogInfo,
  }
}
